module.exports = __webpack_public_path__ + "img/mes-scene-food.dbaded1e.jpg";